// import store from '@/store';
import Vue from "vue";
import VueRouter from "vue-router";
import EmployeeForm from "../views/EmployeeForm.vue";
import LoginOauth from "../views/LoginOauth.vue";
import PageNotFound from "../views/PageNotFound.vue";
// import i18n from '../i18n'
// import getAuth from '../service/getUserService'
// import axios from 'axios'

Vue.use(VueRouter);

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});

// let check_login = false
// let path_url = "";

// const check_auth = async function(to, from,next){
//   if (to.query.token && to.query.acctoken) {
//     const data = await getAuth(to.query.token, to.query.acctoken)
//     console.log(data)
//     console.log(store.getters.isAuthenticated);
//     if (data) {
//       store.dispatch("SetUser", { user: data });
//       check_login = true
//       console.log(path_url)
//       return next()
//     }else {
//       // return next("/login");
//     }
//   }else{
//     return next("/login");
//   }
// }

const routes = [
  {
    path: "/",
    name: "Page not found",
    component: PageNotFound,
    // redirect:"/employee"
  },
  {
    path: "/:token?&:acctoken?",
    name: "Page not found After login",
    component: PageNotFound,
  },
  {
    path: "/employee:token?&:acctoken?",
    name: "Form After Login",
    component: EmployeeForm,
  },
  {
    path: "/employee",
    name: "Employee Form",
    component: EmployeeForm,
    // beforeEnter: (to, from, next) => {
    //   path_url = to.path;
    //   console.log(check_login)
    //   if (check_login) {
    //     next()
    //   }
    //   else{
    //     next("/login");
    //   }
    // }
  },
  {
    path: "/login",
    name: "Login Oauth",
    component: LoginOauth,
  },
  {
    path: "/pagenotfound",
    component: PageNotFound,
  },
  {
    path: "*",
    redirect: "/pagenotfound",
  },
  // {
  //   path: '/:lang',
  //   component: {
  //     render (c) { return c('router-view') }
  //   },
  //   children: [
  // {
  //   path: '/employee',
  //   name: 'home',
  //   component: Home

  // },
  //   ]
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// eslint-disable-next-line no-unused-vars
// router.beforeEach(async (to, from, next) => {
//   await fetch("/static/config.json").then(response => response.json()).then(jsondata => {
//     // this.$config = jsondata;
//     console.log( jsondata);
//     console.log( this.$urlApiFamily);console.log( this.$urlLoginOauth);console.log( this.$tokenOauth);
//     // console.log( this.$config.VUE_APP_API_FAMILY);
//     // console.log( this.$config.VUE_APP_SRITRANG_LOGIN_URL);
//     // console.log( this.$config.VUE_APP_SRITRANG_LOGIN_TOKEN);
//     // axios.defaults.baseURL = this.$config.VUE_APP_API_FAMILY

//   }).catch(error => (console.log(error)));
// });

export default router;
